import(/* webpackMode: "eager" */ "/vercel/path0/web/src/app/responsible-gaming/page.tsx")